import { IAppState } from '../common/state';

export function isAuthenticatedUserSelector(state: IAppState): boolean {
  return state.user.isAuthenticated;
}
